<nav class="navbar-bottom extra" *ngIf="othersMenu" [ngClass]="{'show': showOthers}" aria-label="navbar extra">
    <div class="navbar-bottom-wrapper">
        <div class="d-flex flex-column d-lg-none w-100">
            <div class="d-flex justify-content-around w-100 mt-2" (click)="toggleOthers()">
                <div class="hide-button"></div>
            </div>
            <div class="d-flex icons w-100">
                <ng-container *ngFor="let item of othersMenu">
                    <a class="d-flex flex-column p-2 align-items-center active" (click)="setNewActiveMenuItem(item)"
                        [ngClass]="{'active': item.isActive}">
                        <i class="{{item.icon}} align-self-center icon-2x" aria-hidden="true"></i>
                        <span>{{item.name | translate}}</span>
                    </a>
                </ng-container>
                <ng-container *ngFor="let item of [].constructor(5 - othersMenu.length)">
                    <a class="d-flex flex-column p-2 align-items-center active"></a>
                </ng-container>
            </div>
        </div>
    </div>
</nav>
<nav class="navbar-bottom" aria-label="navbar">
    <div class="navbar-bottom-wrapper">
        <div class="d-flex d-lg-none w-100">
            <div class="d-flex icons justify-content-around w-100">
                <ng-container *ngFor="let item of mainMenu">
                    <ng-container *ngIf="!item.externalLink; else itemExternalLink">
                        <a [id]="item.reference || ''" class="d-flex flex-column p-2 align-items-center active"
                            [ngClass]="{'active': item.isActive}" (click)="setNewActiveMenuItem(item)">
                            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
                        </a>
                    </ng-container>
                    <ng-template #itemExternalLink>
                        <a class="d-flex flex-column p-2 align-items-center active"
                            [ngClass]="{'active': item.isActive}" [edpExternalLink]="item.externalLink | translate">
                            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
                        </a>
                    </ng-template>
                    <ng-template #itemContent>
                        <i class="{{item.icon}} align-self-center icon-2x" aria-hidden="true"></i>
                        <span>{{item.name | translate}}</span>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</nav>